import { mapActions } from 'vuex';
import addFundsCreditCard from '@/components/wallet/add-funds-credit-card/add-funds-credit-card.vue';
import addFundsBankTransfer from '@/components/wallet/add-funds-bank-transfer/add-funds-bank-transfer.vue';
import addFundsTransfers from '@/components/wallet/add-funds-transfers/add-funds-transfers.vue';
import addFundsCash from '@/components/wallet/add-funds-cash/add-funds-cash.vue';
import addFundsCoinbase from '@/components/wallet/add-funds-coinbase/add-funds-coinbase.vue';
import depositTabs from '@/components/wallet/shared/deposit-tabs/deposit-tabs.vue';
import depositPromotionsBanner from '@/components/wallet/shared/deposit-promotions-banner/deposit-promotions-banner.vue';
import feeWaivedBanner from '@/components/wallet/shared/fee-waived-banner/fee-waived-banner.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import feeWaivedBannerMixin from '@/mixins/feeWaivedBannerMixin';
import depositNotificationsMixin from '@/mixins/depositNotificationsMixin';
import { DEPOSIT_METHOD_TYPE, buildDepositMethodTabs } from '@/components/wallet/shared/depositMethodTypes';
import instantCreditService from '@/services/instant-credit';

const ALLOWED_TAB_TYPES = [
  DEPOSIT_METHOD_TYPE.ONLINE_BANKING,
  DEPOSIT_METHOD_TYPE.CREDIT_CARD,
  DEPOSIT_METHOD_TYPE.CASH,
  DEPOSIT_METHOD_TYPE.CRYPTO,
  DEPOSIT_METHOD_TYPE.TRANSFERS,
];

export default {
  mixins: [
    accountVerifyMixin,
    feeWaivedBannerMixin,
    depositNotificationsMixin,
  ],
  components: {
    addFundsBankTransfer,
    addFundsTransfers,
    addFundsCreditCard,
    addFundsCash,
    addFundsCoinbase,
    depositTabs,
    depositPromotionsBanner,
    feeWaivedBanner,
  },
  props: {
    checkInstantCredit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTabs: false,
      hideTabs: false,
      activeTab: null,
      methods: [],
      instantCreditData: {},
    };
  },
  computed: {
    tabs() {
      return buildDepositMethodTabs(this.methods, {
        allowedTypes: ALLOWED_TAB_TYPES,
      });
    },
    showCardTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CREDIT_CARD;
    },
    showBankingTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.ONLINE_BANKING;
    },
    showTransfersTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.TRANSFERS;
    },
    showCashTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CASH;
    },
    showCoinBaseTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CRYPTO;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getStatus']),
    ...mapActions('wallet', ['getDepositMethods']),
    tabChange(name) {
      this.resetChildNotifications();
      this.activeTab = name;
      // upon initial tab change if there is one tab hide options
      if (this.tabs.length === 1) {
        this.hideTabs = true;
      }
    },
    onBankTransferStep(step) {
      if (step === 3) {
        this.hideTabs = true;
      } else if (step === 1 || step === 2) {
        this.hideTabs = false;
      }
    },
  },
  created() {
    this.getDepositMethods().then((data) => {
      this.methods = [...data.depositMethods].sort((a, b) => a.tabIndex - b.tabIndex);

      const shouldGoToWalletPage = this.tabs.length === 0 && this.isUserVerifiedFully;

      if (shouldGoToWalletPage) {
        if (this.$route.name === 'wallet') {
          this.setCurrentPopup();
        } else {
          this.$router.push({ name: 'wallet' });
        }
      } else if (this.checkInstantCredit) {
        instantCreditService.run()
          .then((instantCreditData) => {
            this.instantCreditData = instantCreditData;
            this.showTabs = true;

            if (this.instantCreditData.success) {
              this.getStatus();
            }
          });
      } else {
        this.showTabs = true;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-combined/add-funds-combined.js